import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { I18nextProvider } from "react-i18next";
import i18next from "./i18n";
import { Toaster } from "./components/ui/sonner";
import { toast } from "sonner";
import { initHeader } from "./utils/common";

// Note: ResizeObserver error suppression is handled in public/index.html
// to ensure it runs before CRA's error overlay is initialized.

const updateLanguageClass = (language) => {
  const normalizedLanguage = String(language || "en").toLowerCase();
  const isJapanese = normalizedLanguage.startsWith("ja");
  document.documentElement.lang = language || "en";
  document.body.classList.toggle("noto-sans-jp-base", isJapanese);
};

i18next.on("languageChanged", updateLanguageClass);
i18next.on("languageChanged", () => {
  // Close any toasts shown in the previous language (toasts can't be live-translated).
  toast.dismiss();
  // Ensure API localization header is updated for subsequent requests (Bug MIN-1248 #29).
  initHeader();
});
updateLanguageClass(i18next.language);
document.title = "Fujikin Vietnam";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18next}>
    <App />
    <Toaster />
  </I18nextProvider>
);

serviceWorker.unregister();
